import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-typehead',
  templateUrl: './typehead.component.html',
  styles: []
})
export class TypeheadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
